import _ from "@lodash";
import { Checkbox, FormControl, FormControlLabel, Grid, MenuItem, Paper, Radio, RadioGroup, Switch, TextField, Typography, withStyles } from "@material-ui/core";
import ImageUploader from "app/Core/Components/ImageUploader/ImageUploader";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import * as Helpers from "app/Core/Helpers";
import { GetEspecialidades } from "app/Core/Helpers";
import CIDApp from "app/ERP/CID/CIDApp";
import CidadeApp from "app/ERP/Cidade/CidadeApp";
import EmpresaCategoriaApp from "app/ERP/EmpresaCategoria/EmpresaCategoriaApp";
import EmpresaCentroCustoApp from "app/ERP/EmpresaCentroCusto/EmpresaCentroCustoApp";
import EmpresaContaApp from "app/ERP/EmpresaConta/EmpresaContaApp";
import EmpresaDepartamentoApp from "app/ERP/EmpresaDepartamento/EmpresaDepartamentoApp";
import EmpresaDepositoApp from "app/ERP/EmpresaDeposito/EmpresaDepositoApp";
import EmpresaFuncionarioApp from "app/ERP/EmpresaFuncionario/EmpresaFuncionarioApp";
import EmpresaFornecedorApp from "app/ERP/EmpresaFornecedor/EmpresaFornecedorApp";
import EmpresaGrupoProdutoApp from "app/ERP/EmpresaGrupoProduto/EmpresaGrupoProdutoApp";
import EmpresaPessoaApp from "app/ERP/EmpresaPessoa/EmpresaPessoaApp";
import EmpresaProdutoApp from "app/ERP/EmpresaProduto/EmpresaProdutoApp";
import withReducer from "app/store/withReducer";
import clsx from "clsx";
import JoditEditor from "jodit-react";
import React from "react";
import InputMask from "react-input-mask";
import connect from "react-redux/es/connect/connect";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import XAPPChipSelect from "../ChipSelect/XAPPChipSelect";
import ModeloApp from "../Modelo/ModeloApp";
import Refracao from "../Refracao/Refracao";
import FormularioFactory from "./FormularioFactory";
import FormularioReducer from "./Store/Reducers/FormularioReducer";
import TagFormulario from "../TagFormulario/TagFormulario";
import EmpresaFormaPagamentoApp from "app/ERP/EmpresaFormaPagamento/EmpresaFormaPagamentoApp";
import SuggestionField from "../SuggestionField/SuggestionField";

const styles = (theme) => ({
    item: {
        paddingLeft: 3 * theme.spacing.unit,
    },
    group: {
        fontWeight: theme.typography.fontWeightMedium,
        opacity: 1,
    },
    descricao: {
        color: theme.palette.text.primary
    },
    formControl: {
        paddingLeft: "12px",
        margin: "6px 0",
        width: "100%",
        "&:last-child": {
            marginBottom: 0
        }
    },
    formGroupTitle: {
        position: "absolute",
        top: -10,
        left: 8,
        fontWeight: 600,
        padding: "0 4px",
        backgroundColor: theme.palette.type === "dark" ? "#424242" : "#FFF",
        fontSize: "12px",
    },
    formGroup: {
        position: "relative",
        maxHeight: "58px",
        border: "1px solid " + theme.palette.divider,
        borderRadius: 2,
    },
    spanlabel: {
        top: 9,
        left: 8,
        position: "relative",
        paddingRight: 5,
        paddingLeft: 5,
        fontSize: 12.5,
        fontFamily: "Muli,Roboto,\"Helvetica\",Arial,sans-serif",
        color: theme.palette.text.secondary,
        backgroundColor: theme.palette.background.paper,
        width: "fit-content",
        maxWidth: "fit-content",
    },
    paper: {
        padding: "5px 4px",
        display: "flex",
        alignItems: "center",
        border: "1px solid " + theme.palette.divider,
    },
    cor: {
        color: theme.palette.text.primary,
    },
    GridItemSwitch: {
        padding: "5px 4px",
        display: "flex",
        alignItems: "center",
        color: theme.palette.text.primary,
    }
});

const NewState = {
    idparent: null,
    formulario: null,
    requeridos: null,
    tipo: null,
    filters: null
};

class FormularioApp extends XAPPComponent {

    state = { ...NewState };

    componentDidMount() {
        const form = this.state;
        if (this.props.Formulario && form.formulario === null) {
            var obj = { ...this.props.data };
            var objRequeridos = {};
            if (!_.isUndefined(this.props.Formulario.body) && !_.isNull(this.props.Formulario.body)) {
                this.props.Formulario.body.forEach((groupitem) => {
                    groupitem.campos.forEach((fielditem) => {
                        if (this.props.data) {
                            if (!_.isUndefined(this.props.data[fielditem.id.toLowerCase()]) && !_.isNull(this.props.data[fielditem.id.toLowerCase()])) {
                                obj[fielditem.id.toLowerCase()] = this.props.data[fielditem.id.toLowerCase()];
                            }
                            else {
                                obj = this.setDefaultValue(obj, fielditem);
                            }
                        }
                        else {
                            obj = this.setDefaultValue(obj, fielditem);
                        }
                        objRequeridos[fielditem.id.toLowerCase()] = fielditem.required;
                    });
                });
            }

            this.props.onChange(obj);
            this.props.setRequeridos(objRequeridos);
            this.setState({ formulario: obj, requeridos: objRequeridos });
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const form = this.state;
        if (!_.isEqual(prevState.tabValue, this.state.tabValue)) {
            this.props.clearModelo();
        }

        if (!_.isEqual(prevProps.meusmodelos, this.props.meusmodelos)) {
            this.setState({ idmodelo: null });
        }

        if (!_.isEqual(prevState.idparent, form.idparent) && !_.isNull(this.props.onChangeParent)) {
            this.props.onChangeParent(form.idparent);
        }

        if (!_.isEqual(prevState.formulario, form.formulario)) {
            this.props.onChange(form.formulario);
        }
    }

    componentWillUnmount() {
        this.setState({ formulario: null, requeridos: null, });
    }

    setDefaultValue = (obj, fielditem) => {
        if (!_.isUndefined(fielditem.defaultvalue) && !_.isNull(fielditem.defaultvalue)) {
            obj[fielditem.id.toLowerCase()] = fielditem.defaultvalue;
        }
        else {
            switch (fielditem.component.toLowerCase()) {
                case "":
                    if (_.isUndefined(obj[fielditem.id.toLowerCase()]) || _.isNull(obj[fielditem.id.toLowerCase()])) {
                        obj[fielditem.id.toLowerCase()] = "";
                    }
                    break;
                case "date":
                    obj[fielditem.id.toLowerCase()] = Helpers.GetDataAtual(null, "usa");
                    obj[fielditem.id.toLowerCase() + "descricao"] = Helpers.GetDataAtual(null, "br");
                    break;
                case "datetime-local":
                    obj[fielditem.id.toLowerCase()] = Helpers.GetDataHoraAtual("usa");
                    obj[fielditem.id.toLowerCase() + "descricao"] = Helpers.GetDataHoraAtual("br");
                    break;
                default: obj[fielditem.id.toLowerCase()] = ""; break;
            }
        }
        return obj;
    };

    handleFormulario = (event) => {
        var obj = Object.assign({}, this.state.formulario);
        switch (event.target.type) {
            case "checkbox": obj[event.target.name.toLowerCase()] = event.target.checked; break;
            case "date":
                obj[event.target.name.toLowerCase()] = event.target.value;
                obj[event.target.name.toLowerCase() + "descricao"] = Helpers.StringDateUSToBR(event.target.value);
                break;
            case "datetime-local":
                obj[event.target.name.toLowerCase()] = event.target.value;
                obj[event.target.name.toLowerCase() + "descricao"] = Helpers.StringDateUSToBR(event.target.value);
                break;
            default: obj[event.target.name.toLowerCase()] = event.target.value; break;
        }
        this.setState(_.set({ ...this.state }, "formulario", obj));
    };

    handleFormularioMask = (event) => {
        this.setState({ formulario: _.set({ ...this.state.formulario }, event.target.name.toLowerCase(), Helpers.ReplaceAll(event.target.value, /[^\w\s]/gi, "")) });
    };

    handleFormularioByFormulario = (_AForm) => {
        var obj = Object.assign({}, this.state.formulario);
        Object.keys(_AForm).forEach(key => {
            obj[key] = _AForm[key];
        });
        this.setState(_.set({ ...this.state }, "formulario", obj));
    };

    handleFormularioImage = (_AItem, _AName) => {
        this.setState({ formulario: _.set({ ...this.state.formulario }, _AName.toLowerCase(), _AItem) });
    };

    handleConteudo = (_AName, _AValue) => {
        this.setState({ formulario: _.set({ ...this.state.formulario }, _AName.toLowerCase(), _AValue) });
    };

    canBeSubmited = () => {
        var ACanSubmited = true;
        var objRequeridos = this.state.requeridos;
        var obj = Object.assign({}, this.state.formulario);
        if (this.props.Formulario) {
            this.props.Formulario.body.forEach((groupitem) => {
                groupitem.campos.forEach((fielditem) => {
                    if ((ACanSubmited) && (((obj[fielditem.id.toLowerCase()] === null) || (obj[fielditem.id.toLowerCase()].length < 1)) && (objRequeridos[fielditem.id.toLowerCase()]))) {
                        ACanSubmited = false;
                    }
                });

            });
            return ACanSubmited;
        }
    };

    getLookup = (_AItem) => {
        switch (_AItem.tipo.toUpperCase()) {
            case "EMPRESAPESSOA": return this.getLookupEmpresaPessoa(_AItem);
            case "EMPRESAFORNECEDOR": return this.getLookupEmpresaFornecedor(_AItem);
            case "CIDADE": return this.getLookupCidade(_AItem);
            case "EMPRESAFUNCIONARIO": return this.getLookupEmpresaFuncionario(_AItem);
            case "EMPRESAPRODUTO": return this.getLookupEmpresaProduto(_AItem);
            case "EMPRESAINSUMO": return this.getLookupEmpresaInsumo(_AItem);
            case "EMPRESACATEGORIA_1": return this.getLookupEmpresaCategoria_1(_AItem);
            case "EMPRESACATEGORIA_2_1": return this.getLookupEmpresaCategoria_2_1(_AItem);
            case "EMPRESACATEGORIA_2_2": return this.getLookupEmpresaCategoria_2_2(_AItem);
            case "EMPRESACONTA": return this.getLookupEmpresaConta(_AItem);
            case "EMPRESACENTROCUSTO": return this.getLookupEmpresaCentroCusto(_AItem);
            case "EMPRESADEPOSITO": return this.getLookupEmpresaDeposito(_AItem);
            case "EMPRESADEPARTAMENTO": return this.getLookupEmpresaDepartamento(_AItem);
            case "EMPRESAGRUPOPRODUTO": return this.getLookupEmpresaGrupoProduto(_AItem);
            case "EMPRESAGRUPOPRODUTO_0": return this.getLookupEmpresaGrupoProduto_0(_AItem);
            case "EMPRESAGRUPOPRODUTO_1": return this.getLookupEmpresaGrupoProduto_1(_AItem);
            case "EMPRESAFORMAPAGAMENTO": return this.getLookupEmpresaFormaPagamento(_AItem);
            case "CID": return this.getLookupCID(_AItem);
            default: return null;
        }
    };

    handleLookupCidade = (_AValue = null, fieldId) => {
        var obj = Object.assign({}, this.state.formulario);
        if (!_.isNull(_AValue) && _AValue.length > 0) {
            obj[fieldId] = _AValue[0].id;
            obj["uf"] = _AValue[0].uf;
            obj[fieldId + "_nome"] = _AValue[0].cidade + " - " + _AValue[0].pais;
            this.setState(_.set({ ...this.state }, "formulario", obj));
        }
        else {
            obj[fieldId] = null;
            obj["uf"] = null;
            obj[fieldId + "_nome"] = null;
            this.setState(_.set({ ...this.state }, "formulario", obj));
        }
    };

    handleLookupCID = (_AValue = null, fieldId) => {
        var obj = Object.assign({}, this.state.formulario);
        if (!_.isNull(_AValue) && _AValue.length > 0) {
            obj[fieldId] = _AValue[0].idcid;
            obj[fieldId + "_nome"] = _AValue[0].descricaoabreviada;
            this.setState(_.set({ ...this.state }, "formulario", obj));
        }
        else {
            obj[fieldId] = null;
            obj[fieldId + "_nome"] = null;
            this.setState(_.set({ ...this.state }, "formulario", obj));
        }
    };


    handleLookupEmpresaGrupoProduto = (_AValue = null) => {
        var obj = Object.assign({}, this.state);
        if (!_.isNull(_AValue) && _AValue.length > 0) {
            obj.idparent = _AValue[0].idpessoaformulario;
            obj.formulario.parent = _AValue[0].idpessoaformulario;
            obj.formulario.parent_nome = _AValue[0].nome;
            this.setState(obj);
        }
        else {
            obj.idparent = null;
            obj.formulario.parent = null;
            obj.formulario.parent_nome = null;
            this.setState(obj);
        }
    };

    handleLookupEmpresaPessoa = (_AValue = null, fieldId) => {
        var obj = Object.assign({}, this.state.formulario);
        if (!_.isNull(_AValue) && _AValue.length > 0) {
            obj[fieldId] = _AValue[0].idpessoaformulario;
            obj[fieldId + "_nome"] = _AValue[0].nome;
            obj.uid = _AValue[0].formulario.uid;
            this.setState(_.set({ ...this.state }, "formulario", obj));
        }
        else {
            obj[fieldId] = null;
            obj[fieldId + "_nome"] = null;
            this.setState(_.set({ ...this.state }, "formulario", obj));
        }
    };

    handleLookupEmpresaProduto = (_AValue = null, fieldId) => {
        var obj = Object.assign({}, this.state.formulario);
        if (!_.isNull(_AValue) && _AValue.length > 0) {
            obj[fieldId] = _AValue[0].idpessoaformulario;
            obj[fieldId + "_nome"] = _AValue[0].nome;
            this.setState(_.set({ ...this.state }, "formulario", obj));
        }
        else {
            obj[fieldId] = null;
            obj[fieldId + "_nome"] = null;
            this.setState(_.set({ ...this.state }, "formulario", obj));
        }
    };

    handleLookupEmpresaConta = (_AValue = null, fieldId) => {
        var obj = Object.assign({}, this.state.formulario);
        if (!_.isNull(_AValue) && _AValue.length > 0) {
            obj[fieldId] = _AValue[0].idpessoaformulario;
            obj[fieldId + "_nome"] = _AValue[0].nome;
            this.setState(_.set({ ...this.state }, "formulario", obj));
        }
        else {
            obj[fieldId] = null;
            obj[fieldId + "_nome"] = null;
            this.setState(_.set({ ...this.state }, "formulario", obj));
        }
    };

    handleLookupEmpresaFormaPagamento = (_AValue = null, fieldId) => {
        var obj = Object.assign({}, this.state.formulario);
        if (!_.isNull(_AValue) && _AValue.length > 0) {
            obj[fieldId] = _AValue[0].idpessoaformulario;
            obj[fieldId + "_nome"] = _AValue[0].nome;
            this.setState(_.set({ ...this.state }, "formulario", obj));
        }
        else {
            obj[fieldId] = null;
            obj[fieldId + "_nome"] = null;
            this.setState(_.set({ ...this.state }, "formulario", obj));
        }
    };

    handleLookupEmpresaCentroCusto = (_AValue = null, fieldId) => {
        var obj = Object.assign({}, this.state.formulario);
        if (!_.isNull(_AValue) && _AValue.length > 0) {
            obj[fieldId] = _AValue[0].idpessoaformulario;
            obj[fieldId + "_nome"] = _AValue[0].nome;
            this.setState(_.set({ ...this.state }, "formulario", obj));
        }
        else {
            obj[fieldId] = null;
            obj[fieldId + "_nome"] = null;
            this.setState(_.set({ ...this.state }, "formulario", obj));
        }
    };

    handleLookupEmpresaDepartamento = (_AValue = null, fieldId) => {
        var obj = Object.assign({}, this.state.formulario);
        if (!_.isNull(_AValue) && _AValue.length > 0) {
            obj[fieldId] = _AValue[0].idpessoaformulario;
            obj[fieldId + "_nome"] = _AValue[0].nome;
            this.setState(_.set({ ...this.state }, "formulario", obj));
        }
        else {
            obj[fieldId] = null;
            obj[fieldId + "_nome"] = null;
            this.setState(_.set({ ...this.state }, "formulario", obj));
        }
    };

    handleLookupEmpresaDeposito = (_AValue = null, fieldId) => {
        var obj = Object.assign({}, this.state.formulario);
        if (!_.isNull(_AValue) && _AValue.length > 0) {
            obj[fieldId] = _AValue[0].idpessoaformulario;
            obj[fieldId + "_nome"] = _AValue[0].nome;
            this.setState(_.set({ ...this.state }, "formulario", obj));
        }
        else {
            obj[fieldId] = null;
            obj[fieldId + "_nome"] = null;
            this.setState(_.set({ ...this.state }, "formulario", obj));
        }
    };

    handleLookupEmpresaCategoria = (_AValue = null, fieldId) => {
        var obj = Object.assign({}, this.state.formulario);
        if (!_.isNull(_AValue) && _AValue.length > 0) {
            obj[fieldId] = _AValue[0].idpessoaformulario;
            obj[fieldId + "_nome"] = _AValue[0].nome;
            obj.codigopai = _AValue[0].codigo;
            obj.tipocategoria = _AValue[0].tipocategoria;
            this.setState(_.set({ ...this.state }, "formulario", obj));
        }
        else {
            obj[fieldId] = null;
            obj[fieldId + "_nome"] = null;
            this.setState(_.set({ ...this.state }, "formulario", obj));
        }
    };

    getLookupCidade = (_AItem) => {
        const form = this.state;
        return (
            <CidadeApp
                xappRouteParams={this.props.xappRouteParams}
                isLookup={true}
                multiSelect={false}
                id="FormularioCidade"
                onChange={(ev) => this.handleLookupCidade(ev, _AItem.id.toLowerCase())}
                selected={form.formulario[_AItem.id.toLowerCase()] ? ([{
                    ...form.formulario[_AItem.id.toLowerCase()],
                    "id": form.formulario[_AItem.id.toLowerCase()],
                    "nome": form.formulario[_AItem.id.toLowerCase() + "_nome"],
                    "label": form.formulario[_AItem.id.toLowerCase() + "_nome"]
                }]) : []}
                className="w-full flex flex-col mb-24"
                campoid={"id"}
                camponome={"nome"}
                label={_AItem.label}
            />
        );
    };

    getLookupCID = (_AItem) => {
        const form = this.state;
        return (
            <CIDApp
                xappRouteParams={this.props.xappRouteParams}
                isLookup={true}
                multiSelect={false}
                id="FormularioCID"
                onChange={(ev) => this.handleLookupCID(ev, _AItem.id.toLowerCase())}
                selected={form.formulario[_AItem.id.toLowerCase()] ? ([{
                    ...form.formulario[_AItem.id.toLowerCase()],
                    "id": form.formulario[_AItem.id.toLowerCase()],
                    "nome": form.formulario[_AItem.id.toLowerCase() + "_nome"],
                    "label": form.formulario[_AItem.id.toLowerCase() + "_nome"]
                }]) : []}
                className="w-full flex flex-col mb-24"
                campoid={"id"}
                camponome={"nome"}
                label={_AItem.label}
            />
        );
    };

    getLookupEmpresaGrupoProduto = (_AItem) => {
        const form = this.state;
        return (
            <EmpresaGrupoProdutoApp
                xappRouteParams={this.props.xappRouteParams}
                isLookup={true}
                multiSelect={false}
                id="FormularioEmpresaGrupoProduto"
                onChange={(ev) => this.handleLookupEmpresaGrupoProduto(ev, _AItem.id.toLowerCase())}
                selected={form.formulario[_AItem.id.toLowerCase()] ? ([{
                    ...form.formulario[_AItem.id.toLowerCase()],
                    "id": form.formulario[_AItem.id.toLowerCase()],
                    "nome": form.formulario[_AItem.id.toLowerCase() + "_nome"],
                    "label": form.formulario[_AItem.id.toLowerCase() + "_nome"]
                }]) : []}
                className="w-full flex flex-col mb-24"
                campoid={"idpessoaformulario"}
                camponome={"nome"}
                label={_AItem.label}
            />
        );
    };

    getLookupEmpresaGrupoProduto_0 = (_AItem) => {
        const form = this.state;
        return (
            <EmpresaGrupoProdutoApp
                xappRouteParams={this.props.xappRouteParams}
                isLookup={true}
                multiSelect={false}
                id="FormularioEmpresaGrupoProduto"
                filter={{ AND: [{ Campo: "pessoaformulario.formulario->>''tipo''", Operador: "=", Valor: "0" }] }}
                onChange={(ev) => this.handleLookupEmpresaGrupoProduto(ev, _AItem.id.toLowerCase())}
                selected={form.formulario[_AItem.id.toLowerCase()] ? ([{
                    ...form.formulario[_AItem.id.toLowerCase()],
                    "id": form.formulario[_AItem.id.toLowerCase()],
                    "nome": form.formulario[_AItem.id.toLowerCase() + "_nome"],
                    "label": form.formulario[_AItem.id.toLowerCase() + "_nome"]
                }]) : []}
                className="w-full flex flex-col mb-24"
                campoid={"idpessoaformulario"}
                camponome={"nome"}
                label={_AItem.label}
            />
        );
    };

    getLookupEmpresaGrupoProduto_1 = (_AItem) => {
        const form = this.state;
        return (
            <EmpresaGrupoProdutoApp
                xappRouteParams={this.props.xappRouteParams}
                isLookup={true}
                multiSelect={false}
                id="FormularioEmpresaGrupoProduto"
                filter={{ AND: [{ Campo: "pessoaformulario.formulario->>''tipo''", Operador: "=", Valor: "1" }] }}
                onChange={(ev) => this.handleLookupEmpresaGrupoProduto(ev, _AItem.id.toLowerCase())}
                selected={form.formulario[_AItem.id.toLowerCase()] ? ([{
                    ...form.formulario[_AItem.id.toLowerCase()],
                    "id": form.formulario[_AItem.id.toLowerCase()],
                    "nome": form.formulario[_AItem.id.toLowerCase() + "_nome"],
                    "label": form.formulario[_AItem.id.toLowerCase() + "_nome"]
                }]) : []}
                className="w-full flex flex-col mb-24"
                campoid={"idpessoaformulario"}
                camponome={"nome"}
                label={_AItem.label}
            />
        );
    };

    getLookupEmpresaPessoa = (_AItem) => {
        const form = this.state;
        return (
            <EmpresaPessoaApp
                className="w-full flex flex-col mb-24"
                xappRouteParams={this.props.xappRouteParams}
                onChange={(ev) => this.handleLookupEmpresaPessoa(ev, _AItem.id.toLowerCase())}
                selected={form.formulario[_AItem.id.toLowerCase()] ? ([{
                    ...form.formulario[_AItem.id.toLowerCase()],
                    "id": form.formulario[_AItem.id.toLowerCase()],
                    "nome": form.formulario[_AItem.id.toLowerCase() + "_nome"],
                    "label": form.formulario[_AItem.id.toLowerCase() + "_nome"]
                }]) : []}
                id={"LookupFormularioEmpresa"}
                campoid={"idpessoaformulario"}
                camponome={"nome"}
                required={true}
                isLookup={true}
                multiSelect={false}
                label={_AItem.label}
                target={"spvwempresapessoalookup"}
            />
        );
    };

    getLookupEmpresaFuncionario = (_AItem) => {
        const form = this.state;
        return (
            <EmpresaFuncionarioApp
                xappRouteParams={this.props.xappRouteParams}
                isLookup={true}
                multiSelect={false}
                id="FormularioEmpresaPessoa"
                filter={{ AND: [{ Campo: "pessoaformulario.formulario->>''uid''", Operador: "<>", Valor: "-1" }] }}
                onChange={(ev) => this.handleLookupEmpresaPessoa(ev, _AItem.id.toLowerCase())}
                selected={form.formulario[_AItem.id.toLowerCase()] ? ([{
                    ...form.formulario[_AItem.id.toLowerCase()],
                    "id": form.formulario[_AItem.id.toLowerCase()],
                    "nome": form.formulario[_AItem.id.toLowerCase() + "_nome"],
                    "label": form.formulario[_AItem.id.toLowerCase() + "_nome"]
                }]) : []}
                className="w-full flex flex-col mb-24"
                campoid={"idpessoaformulario"}
                camponome={"nome"}
                label={_AItem.label}
            />
        );
    };

    getLookupEmpresaFornecedor = (_AItem) => {
        const form = this.state;
        return (
            <EmpresaFornecedorApp
                xappRouteParams={this.props.xappRouteParams}
                isLookup={true}
                multiSelect={false}
                id="FormularioEmpresaFornecedor"
                filter={{ AND: [{ Campo: "pessoaformulario.formulario->>''uid''", Operador: "<>", Valor: "-1" }] }}
                onChange={(ev) => this.handleLookupEmpresaPessoa(ev, _AItem.id.toLowerCase())}
                selected={form.formulario[_AItem.id.toLowerCase()] ? ([{
                    ...form.formulario[_AItem.id.toLowerCase()],
                    "id": form.formulario[_AItem.id.toLowerCase()],
                    "nome": form.formulario[_AItem.id.toLowerCase() + "_nome"],
                    "label": form.formulario[_AItem.id.toLowerCase() + "_nome"]
                }]) : []}
                className="w-full flex flex-col mb-24"
                campoid={"idpessoaformulario"}
                camponome={"nome"}
                label={_AItem.label}
            />
        );
    };

    getLookupEmpresaProduto = (_AItem) => {
        const form = this.state;
        return (
            <EmpresaProdutoApp
                xappRouteParams={this.props.xappRouteParams}
                isLookup={true}
                multiSelect={false}
                id="FormularioEmpresaProduto"
                filter={{ AND: [{ Campo: "(pessoaformulario.formulario->>''tipo'')::integer", Operador: "IN", Valor: "(2, 3, 4)" }] }}
                onChange={(ev) => this.handleLookupEmpresaProduto(ev, _AItem.id.toLowerCase())}
                selected={form.formulario[_AItem.id.toLowerCase()] ? ([{
                    ...form.formulario[_AItem.id.toLowerCase()],
                    "id": form.formulario[_AItem.id.toLowerCase()],
                    "nome": form.formulario[_AItem.id.toLowerCase() + "_nome"],
                    "label": form.formulario[_AItem.id.toLowerCase() + "_nome"]
                }]) : []}
                className="w-full flex flex-col mb-24"
                campoid={"idpessoaformulario"}
                camponome={"nome"}
                label={_AItem.label}
            />
        );
    };

    getLookupEmpresaInsumo = (_AItem) => {
        const form = this.state;
        return (
            <EmpresaProdutoApp
                xappRouteParams={this.props.xappRouteParams}
                isLookup={true}
                multiSelect={false}
                id="FormularioEmpresaProduto"
                filter={{ AND: [{ Campo: "(pessoaformulario.formulario->>''tipo'')::integer", Operador: "IN", Valor: "(1, 3)" }] }}
                onChange={(ev) => this.handleLookupEmpresaProduto(ev, _AItem.id.toLowerCase())}
                selected={form.formulario[_AItem.id.toLowerCase()] ? ([{
                    ...form.formulario[_AItem.id.toLowerCase()],
                    "id": form.formulario[_AItem.id.toLowerCase()],
                    "nome": form.formulario[_AItem.id.toLowerCase() + "_nome"],
                    "label": form.formulario[_AItem.id.toLowerCase() + "_nome"]
                }]) : []}
                className="w-full flex flex-col mb-24"
                campoid={"idpessoaformulario"}
                camponome={"nome"}
                label={_AItem.label}
            />
        );
    };

    getLookupEmpresaCentroCusto = (_AItem) => {
        const form = this.state;
        return (
            <EmpresaCentroCustoApp
                xappRouteParams={this.props.xappRouteParams}
                isLookup={true}
                multiSelect={false}
                id="FormularioEmpresaCentroCusto"
                onChange={(ev) => this.handleLookupEmpresaCentroCusto(ev, _AItem.id.toLowerCase())}
                selected={form.formulario[_AItem.id.toLowerCase()] ? ([{
                    ...form.formulario[_AItem.id.toLowerCase()],
                    "id": form.formulario[_AItem.id.toLowerCase()],
                    "nome": form.formulario[_AItem.id.toLowerCase() + "_nome"],
                    "label": form.formulario[_AItem.id.toLowerCase() + "_nome"]
                }]) : []}
                className="w-full flex flex-col mb-24"
                campoid={"idpessoaformulario"}
                camponome={"nome"}
                label={_AItem.label}
            />
        );
    };

    getLookupEmpresaDeposito = (_AItem) => {
        const form = this.state;
        return (
            <EmpresaDepositoApp
                xappRouteParams={this.props.xappRouteParams}
                isLookup={true}
                multiSelect={false}
                id="FormularioEmpresaDeposito"
                onChange={(ev) => this.handleLookupEmpresaDeposito(ev, _AItem.id.toLowerCase())}
                selected={form.formulario[_AItem.id.toLowerCase()] ? ([{
                    ...form.formulario[_AItem.id.toLowerCase()],
                    "id": form.formulario[_AItem.id.toLowerCase()],
                    "nome": form.formulario[_AItem.id.toLowerCase() + "_nome"],
                    "label": form.formulario[_AItem.id.toLowerCase() + "_nome"]
                }]) : []}
                className="w-full flex flex-col mb-24"
                campoid={"idpessoaformulario"}
                camponome={"nome"}
                label={_AItem.label}
            />
        );
    };

    getLookupEmpresaDepartamento = (_AItem) => {
        const form = this.state;
        return (
            <EmpresaDepartamentoApp
                xappRouteParams={this.props.xappRouteParams}
                isLookup={true}
                multiSelect={false}
                id="FormularioEmpresaDepartamento"
                onChange={(ev) => this.handleLookupEmpresaDepartamento(ev, _AItem.id.toLowerCase())}
                selected={form.formulario[_AItem.id.toLowerCase()] ? ([{
                    ...form.formulario[_AItem.id.toLowerCase()],
                    "id": form.formulario[_AItem.id.toLowerCase()],
                    "nome": form.formulario[_AItem.id.toLowerCase() + "_nome"],
                    "label": form.formulario[_AItem.id.toLowerCase() + "_nome"]
                }]) : []}
                className="w-full flex flex-col mb-24"
                campoid={"idpessoaformulario"}
                camponome={"nome"}
                label={_AItem.label}
            />
        );
    };

    getLookupEmpresaConta = (_AItem) => {
        const form = this.state;
        return (
            <EmpresaContaApp
                xappRouteParams={this.props.xappRouteParams}
                isLookup={true}
                multiSelect={false}
                id="FormularioEmpresaConta"
                onChange={(ev) => this.handleLookupEmpresaConta(ev, _AItem.id.toLowerCase())}
                selected={form.formulario[_AItem.id.toLowerCase()] ? ([{
                    ...form.formulario[_AItem.id.toLowerCase()],
                    "id": form.formulario[_AItem.id.toLowerCase()],
                    "nome": form.formulario[_AItem.id.toLowerCase() + "_nome"],
                    "label": form.formulario[_AItem.id.toLowerCase() + "_nome"]
                }]) : []}
                className="w-full flex flex-col mb-24"
                campoid={"idpessoaformulario"}
                camponome={"nome"}
                label={_AItem.label}
            />
        );
    };

    getLookupEmpresaFormaPagamento = (_AItem) => {
        const form = this.state;
        return (
            <EmpresaFormaPagamentoApp
                xappRouteParams={this.props.xappRouteParams}
                isLookup={true}
                multiSelect={false}
                id="FormularioEmpresaFormaPagamento"
                onChange={(ev) => this.handleLookupEmpresaFormaPagamento(ev, _AItem.id.toLowerCase())}
                selected={form.formulario[_AItem.id.toLowerCase()] ? ([{
                    ...form.formulario[_AItem.id.toLowerCase()],
                    "id": form.formulario[_AItem.id.toLowerCase()],
                    "nome": form.formulario[_AItem.id.toLowerCase() + "_nome"],
                    "label": form.formulario[_AItem.id.toLowerCase() + "_nome"]
                }]) : []}
                className="w-full flex flex-col mb-24"
                campoid={"idpessoaformulario"}
                camponome={"nome"}
                label={_AItem.label}
            />
        );
    };

    getLookupEmpresaCategoria_1 = (_AItem) => {
        const form = this.state;
        return (
            <EmpresaCategoriaApp
                xappRouteParams={this.props.xappRouteParams}
                isLookup={true}
                multiSelect={false}
                key="FormularioEmpresaCategoria1"
                id="FormularioEmpresaCategoria1"
                filter={{ AND: [{ Campo: "pessoaformulario.formulario->>''natureza''", Operador: "=", Valor: "1" }] }}
                onChange={(ev) => this.handleLookupEmpresaCategoria(ev, _AItem.id.toLowerCase())}
                selected={form.formulario[_AItem.id.toLowerCase()] ? ([{
                    ...form.formulario[_AItem.id.toLowerCase()],
                    "id": form.formulario[_AItem.id.toLowerCase()],
                    "nome": form.formulario[_AItem.id.toLowerCase() + "_nome"],
                    "label": form.formulario[_AItem.id.toLowerCase() + "_nome"]
                }]) : []}
                className="w-full flex flex-col mb-24"
                campoid={"idpessoaformulario"}
                camponome={"nome"}
                label={_AItem.label}
            />
        );
    };

    getLookupEmpresaCategoria_2_1 = (_AItem) => {
        const form = this.state;
        return (
            <EmpresaCategoriaApp
                xappRouteParams={this.props.xappRouteParams}
                isLookup={true}
                multiSelect={false}
                id="FormularioEmpresaCategoria21"
                key="FormularioEmpresaCategoria21"
                filter={{
                    AND: [{ Campo: "pessoaformulario.formulario->>''natureza''", Operador: "=", Valor: "2" },
                    { Campo: "pessoaformulario.formulario->>''tipocategoria''", Operador: "=", Valor: "1" }]
                }}
                onChange={(ev) => this.handleLookupEmpresaCategoria(ev, _AItem.id.toLowerCase())}
                selected={form.formulario[_AItem.id.toLowerCase()] ? ([{
                    ...form.formulario[_AItem.id.toLowerCase()],
                    "id": form.formulario[_AItem.id.toLowerCase()],
                    "nome": form.formulario[_AItem.id.toLowerCase() + "_nome"],
                    "label": form.formulario[_AItem.id.toLowerCase() + "_nome"]
                }]) : []}
                className="w-full flex flex-col mb-24"
                campoid={"idpessoaformulario"}
                camponome={"nome"}
                label={_AItem.label}
            />
        );
    };

    getLookupEmpresaCategoria_2_2 = (_AItem) => {
        const form = this.state;
        return (
            <EmpresaCategoriaApp
                xappRouteParams={this.props.xappRouteParams}
                isLookup={true}
                multiSelect={false}
                id="FormularioEmpresaCategoria22"
                key="FormularioEmpresaCategoria22"
                filter={{
                    AND: [{ Campo: "pessoaformulario.formulario->>''natureza''", Operador: "=", Valor: "2" },
                    { Campo: "pessoaformulario.formulario->>''tipocategoria''", Operador: "=", Valor: "2" }]
                }}
                onChange={(ev) => this.handleLookupEmpresaCategoria(ev, _AItem.id.toLowerCase())}
                selected={form.formulario[_AItem.id.toLowerCase()] ? ([{
                    ...form.formulario[_AItem.id.toLowerCase()],
                    "id": form.formulario[_AItem.id.toLowerCase()],
                    "nome": form.formulario[_AItem.id.toLowerCase() + "_nome"],
                    "label": form.formulario[_AItem.id.toLowerCase() + "_nome"]
                }]) : []}
                className="w-full flex flex-col mb-24"
                campoid={"idpessoaformulario"}
                camponome={"nome"}
                label={_AItem.label}
            />
        );
    };

    handleSwitch = (event) => {
        var obj = Object.assign({}, this.state.formulario);
        obj[event.target.name] = event.target.checked === true ? "Sim" : "Não";
        this.setState(_.set({ ...this.state }, "formulario", obj));
    };

    handleChangeRadio = (ev) => {
        var obj = Object.assign({}, this.state.formulario);
        obj[ev.target.name] = ev.target.value;
        this.setState(_.set({ ...this.state }, "formulario", obj));

    };

    isSelected = (_ANome, _AValue) => {
        var obj = Object.assign({}, this.state.formulario);
        if (obj[_ANome] === _AValue) {
            return true;
        }
        else {
            return false;
        }
    };

    setModelo = (_AItem) => {
        var AState = JSON.parse(JSON.stringify(this.state));
        AState.formulario = { ...AState.formulario, ..._AItem.conteudo };
        AState.idmodelo = _AItem.idmodelo;
        this.setState(AState);
        this.props.onChange(AState.formulario);
    };

    ifSalvarModelo = () => {
        const { Formulario } = this.props;
        const form = this.state;
        var AResponse = false;
        if (Formulario && !_.isNull(form.formulario) && !_.isNull(form.requeridos) &&
            !_.isUndefined(this.props.Formulario.body) && !_.isNull(this.props.Formulario.body)) {
            Formulario.body.forEach((grupo) => {
                if (!AResponse) {
                    grupo.campos.forEach((item) => {
                        if (!_.isUndefined(item.salvarmodelo) && item.salvarmodelo) {
                            AResponse = true;
                        }
                    });
                }
            });
        }
        return AResponse;
    };

    render() {
        const { Formulario, classes, customProps = null, readOnly, theme, xappRouteParams, tipo, funcionalidade, fluxo = null, pessoaformulario, isGestor } = this.props;
        const form = this.state;

        return (
            <div className="w-full">
                {this.ifSalvarModelo() &&
                    <ModeloApp
                        conteudo={form.formulario}
                        xappRouteParams={xappRouteParams}
                        setModelo={this.setModelo}
                        funcionalidade={funcionalidade}
                        tipo={tipo}
                        Formulario={Formulario}
                    />
                }
                {(Formulario && !_.isNull(form.formulario) && !_.isNull(form.requeridos) && !_.isUndefined(this.props.Formulario.body) && !_.isNull(this.props.Formulario.body)) &&
                    Formulario.body.map((grupo, x) => {
                        return (
                            <React.Fragment key={x}>
                                {!_.isUndefined(grupo.descricao) && grupo.descricao.length > 0 &&
                                    <div className="flex p-8">
                                        <Typography className="inline font-medium" color="primary" paragraph={false}>
                                            {grupo.descricao}
                                        </Typography>
                                    </div>
                                }
                                {grupo.campos.map((item) => {
                                    let checkHidden = false;

                                    if (!_.isNull(customProps) && !_.isUndefined(customProps[item.id]) && !customProps[item.id].show) {
                                        checkHidden = true;
                                    }

                                    if (!checkHidden && !_.isUndefined(item.hidden)) {
                                        item.hidden.forEach(cond => {
                                            if (!checkHidden && (_.isUndefined(form.formulario[cond.id]) || form.formulario[cond.id] === cond.valor)) {
                                                checkHidden = true;
                                                return;
                                            }
                                        });
                                    }

                                    switch (item.component.toUpperCase()) {
                                        case "FOTOS": {
                                            return (
                                                <div className={clsx("flex mb-8 items-center flex-col", checkHidden && "hidden")}>
                                                    <ImageUploader
                                                        onChange={this.handleFormularioImage}
                                                        image={form.formulario[item.id.toLowerCase()]}
                                                        name={item.id.toLowerCase()}
                                                        key={item.id.toLowerCase()}
                                                        width={300}
                                                        showtoolbar={true}
                                                        height={250}
                                                        border={50}
                                                        scale={1}
                                                    />
                                                </div>
                                            );
                                        }
                                        case "SWITCH": {
                                            return (
                                                <div className={clsx("flex", checkHidden && "hidden")}>
                                                    <div className="w-full flex flex-col mb-24">
                                                        <Typography className={classes.spanlabel} color="textSecondary">{item.label}</Typography>
                                                        <Paper className={classes.paper} elevation={0} rounded={true}>
                                                            <div className={classes.GridItemSwitch}>
                                                                <Grid item>Não</Grid>
                                                            </div>
                                                            <Grid component="label" container alignItems="center" spacing={1}>
                                                                <Grid item>
                                                                    <Switch
                                                                        onChange={this.handleSwitch}
                                                                        name={item.id.toLowerCase()}
                                                                        value={form.formulario[item.id.toLowerCase()]}
                                                                        checked={form.formulario[item.id.toLowerCase()] === "Sim" ? true : false}
                                                                    />
                                                                </Grid>
                                                            </Grid>
                                                            <div className={classes.GridItemSwitch}>
                                                                <Grid item>Sim</Grid>
                                                            </div>
                                                        </Paper>
                                                    </div>
                                                </div>
                                            );
                                        }
                                        case "EDITOR": {
                                            return (
                                                <div className={clsx("flex", checkHidden && "hidden")}>
                                                    <JoditEditor
                                                        value={form.formulario[item.id.toLowerCase()]}
                                                        config={{
                                                            readOnly: readOnly,
                                                            language: "pt_br",
                                                            allowResizeX: false,
                                                            allowResizeY: true,
                                                            width: "100%",
                                                            theme: theme.palette.type === "dark" && "dark",
                                                            autofocus: false,
                                                            showCharsCounter: false,
                                                            showWordsCounter: false,
                                                            showXPathInStatusbar: false,
                                                            defaultActionOnPaste: "insert_only_text",
                                                            uploader: {
                                                                insertImageAsBase64URI: true
                                                            }
                                                        }}
                                                        onBlur={(conteudo) => this.handleConteudo(item.id.toLowerCase(), conteudo)}
                                                    />
                                                </div>
                                            );
                                        }
                                        case "DATE": {
                                            return (
                                                <div className={clsx("flex", checkHidden && "hidden")}>
                                                    <TextField
                                                        className="w-full mb-24"
                                                        label={item.label}
                                                        id={item.id.toLowerCase()}
                                                        name={item.id.toLowerCase()}
                                                        value={form.formulario[item.id.toLowerCase()]}
                                                        onChange={this.handleFormulario}
                                                        variant="outlined"
                                                        fullWidth
                                                        disabled={readOnly || item.disabled}
                                                        required={item.required}
                                                        type="date"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                    />
                                                </div>
                                            );
                                        }
                                        case "DATETIME": {
                                            return (
                                                <div className={clsx("flex", checkHidden && "hidden")}>
                                                    <TextField
                                                        className="w-full mb-24"
                                                        label={item.label}
                                                        id={item.id.toLowerCase()}
                                                        name={item.id.toLowerCase()}
                                                        value={form.formulario[item.id.toLowerCase()]}
                                                        onChange={this.handleFormulario}
                                                        variant="outlined"
                                                        fullWidth
                                                        disabled={readOnly || item.disabled}
                                                        required={item.required}
                                                        type="datetime-local"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                    />
                                                </div>
                                            );
                                        }
                                        case "TIME": {
                                            return (
                                                <div className={clsx("flex", checkHidden && "hidden")}>
                                                    <TextField
                                                        className="w-full mb-24"
                                                        label={item.label}
                                                        id={item.id.toLowerCase()}
                                                        name={item.id.toLowerCase()}
                                                        value={form.formulario[item.id.toLowerCase()]}
                                                        onChange={this.handleFormulario}
                                                        variant="outlined"
                                                        fullWidth
                                                        disabled={readOnly || item.disabled}
                                                        required={item.required}
                                                        type="time"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                    />
                                                </div>
                                            );
                                        }
                                        case "TEXTFIELD": {
                                            if (!_.isUndefined(item.mascara) && item.mascara.length > 0) {
                                                return (
                                                    <div className={clsx("flex", checkHidden && "hidden")}>
                                                        <InputMask
                                                            mask={item.mascara}
                                                            maskChar={null}
                                                            value={form.formulario[item.id.toLowerCase()]}
                                                            onChange={(ev) => this.handleFormularioMask(ev)}
                                                        >
                                                            {() => <TextField
                                                                className="mt-8 mb-16"
                                                                label={item.label}
                                                                id={item.id.toLowerCase()}
                                                                name={item.id.toLowerCase()}
                                                                variant="outlined"
                                                                fullWidth
                                                                disabled={readOnly || item.disabled}
                                                                required={item.required}
                                                                InputLabelProps={{
                                                                    shrink: true,
                                                                }}
                                                            />}
                                                        </InputMask>
                                                    </div>
                                                );
                                            }
                                            else {
                                                return (
                                                    <div className={clsx("flex", checkHidden && "hidden")}>
                                                        <TextField
                                                            className="mb-24"
                                                            label={item.label}
                                                            id={item.id.toLowerCase()}
                                                            name={item.id.toLowerCase()}
                                                            value={form.formulario[item.id.toLowerCase()]}
                                                            onChange={this.handleFormulario}
                                                            variant="outlined"
                                                            fullWidth
                                                            disabled={readOnly || item.disabled}
                                                            required={item.required}
                                                            multiline={!_.isUndefined(item.rows) && item.rows > 1}
                                                            type={item.tipo}
                                                            InputLabelProps={{
                                                                shrink: true,
                                                            }}
                                                        />
                                                    </div>
                                                );
                                            }

                                        }
                                        case "COMBOBOX": {
                                            return (
                                                <div className={clsx("flex", checkHidden && "hidden")}>
                                                    <TextField
                                                        className="mb-24"
                                                        label={item.label}
                                                        id={item.id.toLowerCase()}
                                                        name={item.id.toLowerCase()}
                                                        disabled={readOnly || item.disabled}
                                                        value={form.formulario[item.id.toLowerCase()]}
                                                        onChange={this.handleFormulario}
                                                        variant="outlined"
                                                        fullWidth
                                                        select
                                                        required={item.required}
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                    >
                                                        {item.tipo.toLowerCase() === "especialidades" && GetEspecialidades().map(item => (<MenuItem key={"Combo" + item.label + "_" + item.id} value={item.id}>{item.label}</MenuItem>))}
                                                        {item.itens.map(item => (<MenuItem key={"Combo" + item.label + "_" + item.id} value={item.id}>{item.label}</MenuItem>))}
                                                    </TextField>
                                                </div>
                                            );
                                        }
                                        case "CHECKBOX": {
                                            return (
                                                <div className={clsx("flex", checkHidden && "hidden", item.className)}>
                                                    <FormControl className="items-center">
                                                        <FormControlLabel
                                                            label={item.label}
                                                            control={
                                                                <Checkbox
                                                                    id={item.id.toLowerCase()}
                                                                    name={item.id.toLowerCase()}
                                                                    checked={form.formulario[item.id.toLowerCase()] === 1}
                                                                    disabled={readOnly}
                                                                    onChange={(ev) => this.handleFormulario({ "target": { "type": "checkbox", "name": item.id.toLowerCase(), "checked": ev.target.checked ? 1 : 0 } })}
                                                                />
                                                            }
                                                        />
                                                    </FormControl>
                                                </div>
                                            );
                                        }
                                        case "LOOKUP": {
                                            return (
                                                <div className={clsx("flex", checkHidden && "hidden")}>
                                                    {this.getLookup(item)}
                                                </div>
                                            );
                                        }
                                        case "RADIO": {
                                            return (
                                                <React.Fragment>
                                                    <div className={clsx(classes.formGroup, "flex flex-row rounded-6 mb-24", checkHidden && "hidden")}>
                                                        <Typography className={classes.formGroupTitle} color="textSecondary">{item.label + (item.required ? " *" : " ")}</Typography>
                                                        <FormControl component="span" className={classes.formControl} key={item.id.toLowerCase() + "_Paper"} name={item.id.toLowerCase() + "_Paper"}>
                                                            <RadioGroup
                                                                aria-label={item.id.toLowerCase()}
                                                                name={item.id.toLowerCase()}
                                                                value={form.formulario[item.id.toLowerCase()]}
                                                                onChange={ev => this.handleChangeRadio(ev)}
                                                                row={item.itens.length < 4}
                                                                disabled={readOnly || item.disabled}
                                                            >
                                                                {item.itens.map((opt) => (
                                                                    <FormControlLabel key={opt.id} value={opt.id} control={<Radio disabled={readOnly || item.disabled} />} label={opt.label} />
                                                                ))}
                                                            </RadioGroup>
                                                        </FormControl>
                                                    </div>
                                                </React.Fragment>
                                            );
                                        }
                                        case "FACTORY": {
                                            return (
                                                <FormularioFactory
                                                    item={item}
                                                    formulario={form.formulario}
                                                    readOnly={readOnly || item.disabled}
                                                    onChange={this.handleFormulario}
                                                    onChangeMask={this.handleFormularioMask}
                                                    onChangeForm={this.handleFormularioByFormulario}
                                                    onChangeImage={this.handleFormularioImage}
                                                    xappRouteParams={xappRouteParams}
                                                    fluxo={fluxo}
                                                    pessoaformulario={pessoaformulario}
                                                    isGestor={isGestor}
                                                    customProps={customProps}
                                                />
                                            );
                                        }
                                        case "CHIPSELECT": {
                                            return (
                                                <div className={clsx("flex", checkHidden && "hidden")}>
                                                    <XAPPChipSelect
                                                        readOnly={readOnly || item.disabled}
                                                        array={item.itens}
                                                        id={item.id.toLowerCase()}
                                                        label={item.label}
                                                        onChange={this.handleFormulario}
                                                        select={form.formulario[item.id.toLowerCase()]}
                                                        className="mb-24 w-full"
                                                    />
                                                </div>
                                            );
                                        }
                                        case "REFRACAO": {
                                            return (
                                                <div className={clsx("flex", checkHidden && "hidden")}>
                                                    <Refracao
                                                        readOnly={readOnly || item.disabled}
                                                        id={item.id.toLowerCase()}
                                                        onChange={this.handleFormulario}
                                                        formulario={form.formulario}
                                                        className="mb-24 w-full"
                                                    />
                                                </div>
                                            );
                                        }
                                        case "TAGS": {
                                            return (
                                                <div
                                                    className={clsx(classes.formGroup, "w-full flex flex-row rounded-6 mb-12 py-2 h-56")}                 >
                                                    <Typography className={classes.formGroupTitle} color="textSecondary">
                                                        {"Tags"}
                                                    </Typography>
                                                    <FormControl component="span" className={classes.formControl} key={"Tags_Paper"} name={"Tags_Paper"}>
                                                        <TagFormulario
                                                            key={"TagFormularioFormulario"}
                                                            tags={customProps.tags?.data}
                                                            selected={form.formulario.tags}
                                                            target="tags"
                                                            onChange={this.handleFormulario}
                                                            xappRouteParams={xappRouteParams}
                                                            refreshTags={customProps.tags?.callback}
                                                            tipo={customProps.tags?.tipo}
                                                            className="text-20"
                                                        />
                                                    </FormControl>
                                                </div>
                                            );
                                        }
                                        case "SUGGESTION": {
                                            return (
                                                <div className={clsx("flex", checkHidden && "hidden")}>
                                                    <SuggestionField
                                                        className="mb-24"
                                                        name={item.id.toLowerCase()}
                                                        label={item.label}
                                                        xappRouteParams={xappRouteParams}
                                                        target={customProps[item.id.toLowerCase()]?.target}
                                                        campoID={"idpessoaformulario"}
                                                        campoFiltro={`UPPER(pessoaformulario.formulario->>''${item.id.toLowerCase()}'')`}
                                                        required
                                                        value={form.formulario[item.id.toLowerCase()]}
                                                        onSelected={customProps["nome"]?.onSelected}
                                                        onChange={this.handleFormulario}
                                                    />
                                                </div>
                                            );
                                        }
                                        default: {
                                            return <div className="flex"></div>;
                                        }
                                    }
                                })
                                }
                            </React.Fragment>
                        );
                    })}
            </div>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        // list: Actions.list,
    }, dispatch);
}

function mapStateToProps({ fuse }) {
    return {
        theme: fuse.settings.mainTheme
    };
}

export default withReducer("FormularioApp", FormularioReducer)(withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(FormularioApp))));
